import { render, staticRenderFns } from "./PlayBox.vue?vue&type=template&id=1964ea23&scoped=true&lang=pug&"
import script from "./PlayBox.vue?vue&type=script&lang=js&"
export * from "./PlayBox.vue?vue&type=script&lang=js&"
import style0 from "./PlayBox.vue?vue&type=style&index=0&id=1964ea23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964ea23",
  null
  
)

export default component.exports